import React from "react";

function Referral() {
  return (
    <div className="">
      <h2 className="font-2xl">
        Referal Code: <span className="font-semibold">Abc123</span>
      </h2>

      <p>The design for this page is not yet done.</p>
    </div>
  );
}

export default Referral;
